import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import SubcriptionsView from './SubcriptionsView';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import { dataUtil } from '../../services/wsclients/dataUtil';
import { getContactInfo, getCurrency, getDataChangeService, setDataChangeService } from '../../utils/commons';
import CustomLoading from '../../components/CustomLoading';
import ChangeServicesView from './ChangeServicesView';
import ServiceDetailView from './ServiceDetailView';
import { ServiceDetailController } from './ServiceDetailController';
import OrderProgress from '../orders/OrderProgress';
import CustomAlert from '../../components/CustomAlert';
import TerminateConfirm from "./TerminateConfirm";
import ChangeBillingDay from '../home/ChangeBillingDay';
import ProcessFormView from '../register/ProcessFormView';
import { lab4services } from '../../services/wsclients/lab4services';

export default function SubcriptionsController(props) {
    const { t } = useTranslation();
    const history = useHistory();
    const [showLoading, onShowLoading] = useState(false);
    const [subcriptions, setSubcriptions] = useState(null);
    const [service_requests, setServiceRequests] = useState([]);
    const [periodSelected, setPeriodSelected] = useState(null);
    const [periods, setPeriod] = useState([]);
    const [message, setMessage] = useState({});
    const [changeServices, setChangeServices] = useState([]);
    const [showChangeServices, setShowChangeServices] = useState(false);
    const [subscriptionSelected, setSubcriptionSelected] = useState(null);
    const [showDetailService, setShowDetailService] = useState(false);
    const [serviceChangeSelected, setServiceChangeSelected] = useState(null);
    const [serviceDetail, setServiceDetail] = useState(null);

    const [activeStep, setActiveStep] = useState(0);
    const [showProgress, setShowProgress] = useState(false);
    const [showButtonClose, setShowButtonClose] = useState(false);
    const [resultProgress, setResultProgress] = useState({
        step: 0,
        status: null,
        code: null,
        message: null
    });
    const [reasonSelected, setReasonSelected] = useState(null);
    const [listReason, setListReason] = useState([]);
    const [showConfirmTerminate, setShowConfirmTerminate] = useState(false);
    const [terminateSelected, setTerminateSelected] = useState(null);
    const [showBillingDay, setShowBillingDay] = useState(false);
    const [providerOrder, setProviderOrder] = useState(null);
    const [contactId, setContactId] = useState(null);
    const [contactCode, setContactCode] = useState(null);
    const [htmlContent, setHtmlContent] = useState(null);
    const [openProcessForm, setOpenProcessForm] = useState(false);
    const [hiddenLoading, setHiddenLoading] = useState(false);
    useEffect(() => {
        onInit();
    }, [])

    useEffect(()=>{
        let changeServiceData = localStorage.getItem("change_service");
        if(changeServiceData){
            changeServiceData = JSON.parse(changeServiceData);
            if(changeServiceData.status_payment){
                onChangeServiceMetrofibre(changeServiceData)
            }else{
                localStorage.removeItem("change_service")
            }
        }
    },[])

    const onChangeServiceMetrofibre = async (body) => {
        setShowButtonClose(true)
        setShowProgress(true);
        try {
            let result = await wsclients.lab4services.onChangeServiceMetrofibre(body);
            console.log("onChangeServices result ====", result);
            // result.code = 'OK'//hardcode for test
            if (result.code === 'OK') {
                localStorage.removeItem("change_service")
                setHiddenLoading(true)
                setActiveStep(1);
                setResultProgress({
                    step: 0,
                    status: 'change_service_vumatel_success',
                    message: t('change_service_vumatel_success')
                });
            } 
        }
        catch (ex) {
            console.log("onChangeServices exception===", ex);
        }
    }
    useEffect(()=>{
        if(getDataChangeService() && getDataChangeService().url && subcriptions){
            onSwarpService(subcriptions[0])
            localStorage.removeItem("change_service")
        }
    },[subcriptions])
    const onSwarpService = async (subscription) => {
        try {
            onShowLoading(true);
            setSubcriptionSelected(subscription);
            let product = subscription && subscription.service && subscription.service.product ? subscription.service.product : null;
            let result = await wsclients.lab4services.getChangeServices(product && product.id ? product.id : null);
            if (result.code === 'OK') {
                if (result.data) {
                    setChangeServices(result.data);
                    setShowChangeServices(true);
                } else {
                    onShowMessage({ show: true, content: t('can_not_up_downgrade') });
                }
            }
            onShowLoading(false);
        }
        catch (ex) {
            console.log("onSwarpService exception===", ex);
        }
    }

    const onEstimateServices = async (service) => {
        onShowLoading(true)
        try {
            let price = service && service.prices && service.prices.length > 0 ? service.prices[0] : null;
            setServiceChangeSelected(service);
            let result = await wsclients.lab4services.onEstimateServices({
                action: service.change_type,
                from_service_id: subscriptionSelected && subscriptionSelected.service && subscriptionSelected.service.id ? subscriptionSelected.service.id : null,
                to_service_id: service && service.id ? service.id : null,
                to_price_terms_id: price && price.id ? price.id : null,
                scheduled_date:subscriptionSelected.service.terms.termed_period.end_date
            });
            console.log("result onEstimateServices===", result);
            if (result.code === 'OK') {
                let total = 0;

                if (result?.data?.service_delivery_estimate?.length > 0) {
                for (let i = 0; i < result.data.service_delivery_estimate.length; i++) {
                    const element = result.data.service_delivery_estimate[i];
                    const invoicingList = element.billing_estimate?.invoicing || [];
                    
                    for (let j = 0; j < invoicingList.length; j++) {
                    total += invoicingList[j]?.amount_due || 0;
                    }
                }
                }
                console.log("AAAA total",total)
                if(total > 0){
                    setDataChangeService({
                        scheduled_date:subscriptionSelected.service.terms.termed_period.end_date,
                        price_terms_id:service&& service.prices && service.prices.length>0&&
                        service.prices[0].id,
                        product_id:service.id,
                        status_payment:false
                    })
                     await onContinuePayment(total);
                    return;
                }
                console.log("AAAA total",total)
                setServiceDetail(result.data);
                setShowDetailService(true);
            } else {

                onShowMessage({ show: true, content:result?.data?.error?.message?result?.data?.error?.message : t('change_service_failed') })
            }
        }
        catch (ex) {
            console.log("onChangeServices exception===", ex);
        }
        onShowLoading(false)
    }

    console.log("AAAAA htmlContent",htmlContent)
    const onContinuePayment = async (amount) => {
      
        try {
            let contact_info = await wsclients.contacts.getContact();
            if(contact_info.code != "OK"){
                onShowMessage({
                    show: true,
                    message: "Contact not found",
                    isConfirm: true,
                    confirmAction: {
                        okAction: async () => await onContinuePayment(amount),
                        okTitle: t('btn_try'),
                        cancelTitle: t('btn_close'),
                        cancelAction: () => history.push(paths.home),
                    },
                })
            }
            contact_info = contact_info.data;
            let body = {
                contact_id: contact_info.id ? contact_info.id : null,
                email_address: contact_info && contact_info.email ? contact_info.email : null,
                contact_code: contact_info && contact_info.code ? contact_info.code : null,
                amount: amount,
                crm_order_id:"8b1511a0-64b8-4a75-ad1e-aec00ae542e1"
            };
            // debugger;
            let  result = await lab4services.initTopup(body);
           
            console.log("AAAA initPayment result: ", result);
            if (result.code == 'OK') {
                let urlFormPaygate = document._portalConfig.urlFormPaygate;
                if (result && result.code === 'OK' && result.data && result.data.client_token) {
                    let clientToken = result.data.client_token;
                    var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                    console.log('splitToken:', splitToken);
                    if (splitToken.length > 0) {
                        var payRequestIDRes = splitToken[0];
                        var checkSumRes = splitToken[1];
                        var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                            + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                            + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                            + '</form>'
                        console.log('htmlContent:', htmlContent);
                        // setPaymentLinkInfo(paymentInfo);
                        setHtmlContent(htmlContent);
                        setOpenProcessForm(true);
                    }
                } else if (result.data && result.data.state === 'REJECTED') {
                    onShowMessage({
                        show: true,
                        message: t('INIT_PAYMENT_FAILED'),
                        isConfirm: true,
                        confirmAction: {
                            okAction: async () => await onContinuePayment(amount),
                            okTitle: t('btn_try'),
                            cancelTitle: t('btn_close'),
                            cancelAction: () => history.push(paths.home),
                        },
                    });
                }
            }
        } catch (ex) {
            console.log("AAAA onContinuePayment exception: ", ex);
        }
       
    }
    const onInit = async () => {
        await onLoadContact();

        let data = await onLoadSubcriptions();
        if (data && data.length > 0) {
            let periodData = dataUtil.groupBillingPeriod(data);
            console.log("periodData===", periodData);
            if (periodData && periodData.length > 0) {
                setPeriodSelected(periodData[0]);
            }
        }
    }

    const onLoadContact = async () => {
        let contact_info = null;
        try {
            var result = await wsclients.contacts.getContact();
            if (result.code === 'OK') {
                contact_info = result.data;
                setContactId(result.data.id)
                setContactCode(result.data.code)
                if (result.data && result.data.custom_fields && result.data.custom_fields.length > 0) {
                    let existProviderOrder = result.data.custom_fields.filter(x => x.key == 'provider_order');
                    if (existProviderOrder && existProviderOrder.length > 0) {
                        setProviderOrder(existProviderOrder[0].value);
                    }
                }
            }
        } catch (ex) {
            console.log("onLoadContact exception===", ex);
        }
        return contact_info;
    }

    const onChangeTab = (period) => {
        setPeriodSelected(period);
    }

    const onLoadSubcriptions = async (isRefresh) => {
        onShowLoading(isRefresh ? false : true);
        var subscriptionServices = [];
        try {
            const result = await wsclients.contacts.getListContactServices();
            console.log("result:", result);
            if (result.code == 'OK') {
                let data = result.data.content ? result.data.content : []
                for (let i = 0; i < data.length; i++) {
                    let subscriptionService = data[i];
                    let product = subscriptionService.service ? subscriptionService.service.product : null;
                    if (subscriptionService.service && subscriptionService.service.price && subscriptionService.service.price.price) {
                        product.price = subscriptionService.service.price.price;
                    }
                    if (product) {
                        // let info = await wsclients.contacts.getProductDetail(product.id);
                        let info = await wsclients.lab4services.getServiceProduct(product.id);
                        console.log("product info:", info);
                        if (info.code == 'OK') {
                            console.log("info.data.creatives:", info.data.creatives);
                            product.creatives = info.data.creatives;
                            if (info.data && info.data.price) product.price = info.data.price;
                            product.family = info.data.family ? info.data.family : null;
                            product.type = info.data && info.data.type ? info.data.type : null;
                        }
                    }
                    subscriptionServices.push(subscriptionService);
                }
            }
            console.log("subscriptionServices:", subscriptionServices);
            setSubcriptions(subscriptionServices);
            // setPeriod(dataUtil.groupBillingPeriod(subscriptionServices));
        } catch (ex) {
            console.log("on load subscription ex:", ex);
        }
        onShowLoading(false);
        return subscriptionServices;
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    const onTerminate = async (values) => {
        onShowMessage({});
        onShowLoading(true);
        setShowProgress(true);
        setShowConfirmTerminate(false);
        try {
            const { reason_id } = values;
            let service_id = terminateSelected && terminateSelected.service && terminateSelected.service.id ? terminateSelected.service.id : null;
            let serviceFrom = terminateSelected && terminateSelected.service && terminateSelected.service.product ? terminateSelected.service.product : null
            console.log("serviceFrom AAAAAA===", serviceFrom);
            let current_product_id = serviceFrom && serviceFrom.id ? serviceFrom.id : null;
            if (providerOrder && providerOrder == 'openserve') {
                await onTerminateVumatel(service_id, reason_id, current_product_id);
            } else {
                await onTerminateOpenserve(service_id, reason_id, current_product_id);
            }
        } catch (ex) {
            console.log("onTerminate exception===", ex);
        }
        onShowLoading(false)
        //setShowProgress(false);
    }

    const onTerminateVumatel = async (service_id, reason_id, current_product_id) => {
        onShowLoading(true)
        try {
            let result = await wsclients.lab4services.onTerminateVumatel(service_id, reason_id, current_product_id);
            console.log("onTerminateVumatel result ====", result);
            if (result.code === 'OK') {
                setActiveStep(1);
                setResultProgress({
                    step: 1,
                    status: 'terminate_vumatel_success',
                    message: t('terminate_vumatel_success')
                });
                await onTerminateCRM(service_id);
            } else if (result.code === 'VUMATEL_SERVER_ERROR') {
                setActiveStep(0);
                setResultProgress({
                    step: 0,
                    status: 'ERROR',
                    message: t('SERVER_ERROR')
                });
                setShowButtonClose(true);
            }
            else {
                let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                setActiveStep(0);
                setResultProgress({
                    step: 0,
                    status: 'ERROR',
                    message: entityError && entityError.detail && typeof (entityError.detail) === 'string' ? entityError.detail : t('terminate_vumatel_failed')
                });
                setShowButtonClose(true);
            }
        }
        catch (ex) {
            console.log("onTerminateVumatel exception===", ex);
        }
        onShowLoading(false)
    }

    const onTerminateOpenserve = async (service_id, reason_id, current_product_id) => {

        console.log("toan")
        // onShowLoading(true)
        // try {
        //     let result = await wsclients.lab4services.onTerminateOpenserve(service_id, reason_id, current_product_id);
        //     console.log("onTerminateOpenserve result ====", result);
        //     if (result.code === 'OK') {
        //         setActiveStep(1);
        //         setResultProgress({
        //             step: 1,
        //             status: 'terminate_openserve_success',
        //             message: t('terminate_openserve_success')
        //         });
        //         await onTerminateCRM(service_id);
        //     } else if (result.code === 'OPENSERVE_SERVER_ERROR') {
        //         setActiveStep(0);
        //         setResultProgress({
        //             step: 0,
        //             status: 'ERROR',
        //             message: t('SERVER_ERROR')
        //         });
        //         setShowButtonClose(true);
        //     }
        //     else {
        //         let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
        //         setActiveStep(0);
        //         setResultProgress({
        //             step: 0,
        //             status: 'ERROR',
        //             message: entityError && entityError.detail && typeof (entityError.detail) === 'string' ? entityError.detail : t('terminate_openserve_failed')
        //         });
        //         setShowButtonClose(true);
        //     }
        // }
        // catch (ex) {
        //     console.log("onTerminateVumatel exception===", ex);
        // }
        // onShowLoading(false)
    }

    const onTerminateCRM = async (service_id) => {
        onShowLoading(true)
        try {
            let result = await wsclients.lab4services.onTerminateCRM(service_id);
            console.log("onTerminateCRM result ====", result);
            if (result.code === 'OK') {
                setActiveStep(2);
                setResultProgress({
                    step: 2,
                    status: 'terminate_crm_success',
                    message: t('terminate_crm_success')
                });
                setShowButtonClose(true);
                await onInit();
                setShowProgress(false);
            } else {
                setActiveStep(1);
                setResultProgress({
                    step: 1,
                    status: 'ERROR',
                    message: t('terminate_crm_failed')
                });
                setShowButtonClose(true);
            }
        }
        catch (ex) {
            console.log("onTerminateCRM exception===", ex);
        }
        onShowLoading(false)
    }

    const getSteps = () => {
        if (providerOrder && providerOrder == 'openserve') {
            return [t('change_service_openserve'), t('change_service_crm')];
        } else if(providerOrder && providerOrder == 'metrofibre'){
            return [];
        } else{
            return [t('change_service_vumatel'), t('change_service_crm')];
        }
    }

    const onCloseProgress = async() => {
        setShowProgress(false);

        setResultProgress({
            step: 0,
            status: null,
            message: null
        });
        await onLoadSubcriptions()
    }

    const getTerminateReason = async () => {
        let list_reason = [];
        onShowLoading(true)
        try {
            let result = await wsclients.lab4services.getTerminateReason();
            console.log("getTerminateReason result ====", result);
            if (result.code == 'OK') {
                list_reason = result.data.filter(x => x.active === true);
                setListReason(list_reason);
                setShowConfirmTerminate(true)
            }
        }
        catch (ex) {
            console.log("getTerminateReason exception===", ex);
        }
        onShowLoading(false)
        return list_reason;
    }

    const onConfirmTerminate = async (service) => {
        try {
            setTerminateSelected(service);
            let list_reason = await getTerminateReason();
            if (list_reason && list_reason.length > 0) {
                setShowConfirmTerminate(true);
            }
        }
        catch (ex) {
            console.log("onConfirmTerminate exception===", ex);
        }
    }

    const onCancel = async (service) => {
        console.log("onCancel service", service);
        let subscriptionId = service?.subscription?.id
        if (providerOrder == 'openserve') {
            let body = {
                subscription_id: subscriptionId,
                sku: service?.service?.product?.sku,
                product_id: service?.service?.product?.id,
                contact_id: contactId,
                contact_code: contactCode
            }
            let result = await wsclients.lab4services.onCancelServiceOpenserve(body)
            if (result.code == 'OK') {
                onShowMessage({ show: true, content: t('CANCELLED') });
                onInit();
            }
            else {
                onShowMessage({ show: true, content: t('CANCEL_FAILED') });
            }
        } else {
            let body = {
                action: 'CANCEL',
            }
            let result = await wsclients.lab4services.onChangeServiceVumatel(body);
            console.log("onChangeServices result ====", result);
            if (result.code == 'OK') {
                onShowMessage({ show: true, content: t('CANCELLED') });
                onInit();
            }
            else {
                onShowMessage({ show: true, content: t('CANCEL_FAILED') });
            }
        }
    }

    const onChangeBillingDay = (item) => {
        setSubcriptionSelected(item);
        setShowBillingDay(true);
    }


    return (
        <>
            <SubcriptionsView
                periods={periods}
                subcriptions={subcriptions}
                periodSelected={periodSelected}
                currency={getCurrency()}
                onSwarpService={onSwarpService}
                onChangeTab={onChangeTab}
                onTerminate={onConfirmTerminate}
                onChangeBillingDay={onChangeBillingDay}
                providerOrder={providerOrder}
                onCancel={onCancel}
            />
            {showChangeServices && <ChangeServicesView
                open={showChangeServices}
                changeServices={changeServices}
                currency={getCurrency()}
                onClose={() => setShowChangeServices(false)}
                onEstimateServices={onEstimateServices}
            />}
            {openProcessForm && <ProcessFormView
                open={openProcessForm}
                onClose={() => setOpenProcessForm(false)}
                html_content={htmlContent}
            />}
            {showDetailService && <ServiceDetailController
                open={showChangeServices}
                service={serviceDetail}
                serviceChangeSelected={serviceChangeSelected}
                subscriptionSelected={subscriptionSelected}
                providerOrder={providerOrder}
                currency={getCurrency()}
                onClose={() => setShowDetailService(false)}
                contactId={contactId}
                onCloseAll={() => {
                    setShowDetailService(false)
                    setShowChangeServices(false)
                }}
                onLoad={onInit}
            />}
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                onClose={() => onShowMessage({})}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                showButtonClose={true}
            />}
            {showProgress && <OrderProgress
                open={showProgress}
                t={t}
                orderInfo={resultProgress}
                title={t('change_service')}
                sub_title={t('change_service_progress')}
                steps={getSteps()}
                activeStep={activeStep}
                showButtonClose={showButtonClose}
                onClose={() => onCloseProgress()}
                hiddenLoading={hiddenLoading}
            />}
            {showConfirmTerminate && <TerminateConfirm
                open={showConfirmTerminate}
                reasonSelected={reasonSelected}
                listReason={listReason}
                onTerminate={onTerminate}
                onClose={() => setShowConfirmTerminate(false)}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
            {showBillingDay && <ChangeBillingDay
                open={showBillingDay}
                onClose={() => setShowBillingDay(false)}
                subscriptionSelected={subscriptionSelected}
                onRefresh={onInit}
            />}
        </>
    );
}